import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { validations }  from "apps/actions/validations";
import { save }         from "apps/actions/common";
import serializeJSON    from 'utilities/serialize_json';
import Timelag          from 'utilities/timelag'
import { Global }       from 'mixs/orders/planner/model';
class Form extends BaseAjaxForm {
  validFunction = validations.schedule;
  submitFunction = save;
}
class FormCreate extends Form {
  protected setValidations(){
    this.watchAbout('phase_id', this.onChangePhaseId);
  }
  public onChangePhaseId(newVal: any, oldVal: any, objectPath: string){
    if(newVal != null && newVal != ''){
      this.submit();
    }
  }
}
class FormUpdate extends Form {
  lag: Timelag;
  times:number = 0;
  init(){
    super.init();
    this.lag = new Timelag(() => { this.onChangeStoreDo() }, 1000)
  }
  onChangeStore(newVal: any, oldVal: any, objectPath: string){
    super.onChangeStore(newVal, oldVal, objectPath);
    if(newVal.action == oldVal.action && newVal.inputs.daterange.value == oldVal.inputs.daterange.value){
      return;
    }
    this.lag.start();
  }
  onChangeStoreDo(){
    let scheduleId = this.opts.schedule_id;
    if(Global.getScheduleData(scheduleId).dragging){ return; };
    let scope = Global.dataScopeSchedule(scheduleId);
    let newVal = {};
    newVal[scope] = { updating: true };
    this.dispatchNewValue(newVal);
    this.submit();
  }
}

riot.mixin('forms.schedules.create', FormCreate as riot.TagMixin)
riot.mixin('forms.schedules.update', FormUpdate as riot.TagMixin)
